var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Pridajte poznámku")]), !_vm.loading ? _c('button', {
    staticClass: "w-button saveformBtn",
    attrs: {
      "form": "note-create"
    }
  }, [_vm._v("Uložiť")]) : _c('v-progress-circular', {
    staticClass: "loading-spinner small transparent",
    attrs: {
      "indeterminate": ""
    }
  })], 1), _c('form', {
    attrs: {
      "id": "note-create"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveNote.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "popup-block"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.clientNote,
      expression: "clientNote"
    }],
    staticClass: "ui-autocomplete-input",
    attrs: {
      "required": "",
      "placeholder": "Napíšte si poznámku ku klientovi",
      "rows": "20",
      "name": "comment[text]",
      "id": "comment_text",
      "cols": "40",
      "autocomplete": "off",
      "role": "textbox",
      "aria-autocomplete": "list",
      "aria-haspopup": "true"
    },
    domProps: {
      "value": _vm.clientNote
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.clientNote = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "input-group mt-3"
  }, [_c('label', {
    staticClass: "field-label"
  }, [_vm._v("Pripomenúť ?")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.noteReminderDate,
      expression: "noteReminderDate"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "name": "dateOfBirth",
      "type": "date",
      "maxlength": "256",
      "min": _vm.today
    },
    domProps: {
      "value": _vm.noteReminderDate
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.noteReminderDate = $event.target.value;
      }
    }
  })])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }